export class ExpenseBreakdownResultDto {
    fund: string;
    fundName: string;
    bucketCode: string;
    balance: number;
    percentage: number;
    title: string;
}
